import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Manages the "@ Add context" popover: search, select, and manage pinned context items.
// Search results and pills are rendered via Turbo Stream from the server.
export default class extends Controller {
  static targets = ["popover", "searchInput", "results", "pills", "hiddenField"]
  static values = { url: String, selected: { type: Array, default: [] } }

  connect() {
    this.activeCategory = ""
    this.debounceTimer = null
  }

  toggle() {
    this.popoverTarget.classList.toggle("hidden")
    if (!this.popoverTarget.classList.contains("hidden")) {
      this.searchInputTarget.focus()
    }
  }

  close() {
    this.popoverTarget.classList.add("hidden")
  }

  selectCategory(event) {
    this.activeCategory = event.currentTarget.dataset.category || ""

    this.element.querySelectorAll("[data-tab]").forEach((tab) => {
      const isActive = tab.dataset.category === this.activeCategory
      tab.classList.toggle("badge-primary", isActive)
      tab.classList.toggle("badge-ghost", !isActive)
      tab.classList.toggle("hover:badge-outline", !isActive)
    })

    this.search()
  }

  onSearchInput() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.search(), 250)
  }

  async search() {
    const query = this.searchInputTarget.value.trim()
    const params = new URLSearchParams()
    if (query) params.set("q", query)
    if (this.activeCategory) params.set("category", this.activeCategory)
    params.set("selected_ids", JSON.stringify(this.selectedValue.map((s) => `${s.type}-${s.id}`)))

    await this.fetchTurboStream(`${this.urlValue}?${params}`)
  }

  addItem(event) {
    const item = JSON.parse(event.currentTarget.dataset.item)
    const key = `${item.type}-${item.id}`

    if (this.selectedValue.some((s) => `${s.type}-${s.id}` === key)) return

    this.selectedValue = [...this.selectedValue, item]
    this.syncHiddenField()
    this.close()
    this.refreshPills()
  }

  removeItem(event) {
    const type = event.currentTarget.dataset.type
    const id = event.currentTarget.dataset.id
    this.selectedValue = this.selectedValue.filter(
      (s) => !(s.type === type && String(s.id) === String(id))
    )
    this.syncHiddenField()
    this.refreshPills()
  }

  syncHiddenField() {
    if (this.hasHiddenFieldTarget) {
      this.hiddenFieldTarget.value = JSON.stringify(this.selectedValue)
    }
  }

  async refreshPills() {
    const params = new URLSearchParams()
    params.set("items", JSON.stringify(this.selectedValue))
    await this.fetchTurboStream(`${this.urlValue}/pills?${params}`)
  }

  // Shared Turbo Stream fetch — used by search() and refreshPills()
  async fetchTurboStream(url) {
    try {
      const response = await fetch(url, {
        headers: { Accept: "text/vnd.turbo-stream.html" }
      })
      if (!response.ok) return
      await Turbo.renderStreamMessage(await response.text())
    } catch {
      // Silently fail on network errors
    }
  }
}
